import { EventName } from 'features/cantileverAISystem/eventName'
import { z } from 'zod'

export type EventData = z.ZodObject<Record<string, z.ZodType>>

export const enforceDescriptions = (
  eventName: EventName,
  schema: EventData
): void => {
  const enforceDescriptionsOnObject = (schema: EventData, path: string[]) => {
    Object.entries(schema.shape).forEach(([key, zodValue]) => {
      const currentPath = [...path, key]
      if (!zodValue.meta()) {
        throw new Error(
          `Invalid Event Data Schema for event ${eventName}: Field "${currentPath.join('.')}" is missing a description. Please add a .meta() annotation to the field.`
        )
      }
      if (zodValue instanceof z.ZodObject) {
        enforceDescriptionsOnObject(zodValue, currentPath)
      }
    })
  }

  if (!schema.meta()) {
    throw new Error(
      `Invalid Event Data Schema for event ${eventName}: Root of schema is missing metadata. Please add a .meta() annotation to the outer most object of the schema.`
    )
  }
  enforceDescriptionsOnObject(schema, [])
}
